// src/components/RequestHeadline.jsx
//
// Leads the Raw requests detail pane: a plain-language headline (utils/rowHeadline.js)
// and the raw params folded away beneath it. Slot Story step 4, AC 3.19-3.21, 3.35.
import React from 'react';

export const RAW_PARAMS_LABEL = 'Raw params';

export default function RequestHeadline({ headline, children }) {
  const h = headline || { text: '', kind: 'plain', notes: [] };
  const notes = Array.isArray(h.notes) ? h.notes : [];
  return (
    <div data-testid="request-headline-wrap">
      <div
        data-testid="request-headline"
        data-kind={h.kind}
        style={{
          margin: '8px 12px 6px', padding: '8px 10px', borderRadius: 8,
          background: 'var(--surface, var(--bg))', border: '1px solid var(--line)',
          color: 'var(--ink)', fontSize: 13, fontWeight: 600, lineHeight: 1.4,
        }}
      >
        {h.text}
        {notes.map((n) => (
          <div
            key={n.code}
            data-testid="request-headline-note"
            title={n.code}
            style={{ marginTop: 4, fontSize: 11, fontWeight: 500, color: 'var(--info-text, var(--muted))' }}
          >
            {n.msg}
          </div>
        ))}
      </div>
      <details data-testid="raw-params" style={{ margin: '0 12px 8px' }}>
        <summary style={{ cursor: 'pointer', fontSize: 12, color: 'var(--muted)' }}>{RAW_PARAMS_LABEL}</summary>
        {children}
      </details>
    </div>
  );
}
